import styled from "styled-components";
import { useArtistContext, useMenuContext } from "Components";
import { useParams } from "react-router-dom";
import { LinkItem, Link } from "./Components/Link";
import { SvgMusic } from "melodies-source/Svgs/Music";
import { SvgSetList } from "melodies-source/Svgs/SetList";
import { SvgAudience } from "melodies-source/Svgs/Audience";
import { SvgVideoChat } from "melodies-source/Svgs/VideoChat";
import { useCustomAppContext } from "contexts/CustomAppContext";
import { ReactComponent as ClipboardIcon } from "assets/svg/clipboard-fill.svg";
import { SvgClipboard } from "melodies-source/Svgs/Clipboard";
import { useUser } from "auth";

export const AppLinks = () => {
  const context = useArtistContext();
  const setlive = process.env.REACT_APP_SL_URL;
  const sts = context?.privateData?.data()?.settheset;
  const mgAdmin = process.env.REACT_APP_MGA_URL;
  const so = process.env.REACT_APP_SO_URL;
  const { artistId } = useParams<{ artistId: string }>();
  const { menuMode } = useMenuContext();
  const { customApp } = useCustomAppContext();
  const { claims } = useUser();

  const links: LinkItem[] = [
    {
      icon: customApp ? (
        customApp.menu.sections.engagement.items.live.icon || <ClipboardIcon />
      ) : (
        <SvgMusic />
      ),
      label: customApp?.menu.sections.engagement.items.live.label || "SET.Live",
      to: `/${artistId}/set-live`,
    },
    ...(sts && !customApp
      ? [
          {
            icon: <SvgSetList />,
            label: "Livestream",
            onClick: () => window.open(setlive, "_blank"),
          },
        ]
      : []),
    ...(!customApp
      ? [
          {
            icon: <SvgClipboard />,
            label: "SET.Fan",
            to: `/${artistId}/set-fan/surveys`,
          },
        ]
      : []),
    ...(!customApp
      ? [
          {
            icon: <SvgAudience />,
            label: "Meet & Greet",
            onClick: () =>
              window.open(`${mgAdmin}/artist/${context.id}/events`, "_blank"),
          },
        ]
      : []),
    ...(so && !customApp
      ? [
          {
            icon: <SvgVideoChat />,
            label: "ShoutOut",
            onClick: () =>
              window.open(`${so}/messages/${context.id}`, "_blank"),
          },
        ]
      : []),
  ];
  return (
    <Container>
      {menuMode === "expanded" && (
        <Header>
          {customApp?.menu.sections.engagement.header || "Fan Engagement Tools"}
        </Header>
      )}
      {links.map((link) => (
        <Link key={link.label} {...link} />
      ))}
    </Container>
  );
};

const Header = styled.h1`
  color: var(--sidebar-section-header-color);
  font-family: Poppins;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 21px;
  padding: 0 0 12px 20px;
`;

const Container = styled.div`
  box-shadow: inset 0 1px 0 0 var(--box-shadow-color),
    inset 0 -1px 0 0 var(--box-shadow-color);
  padding: 16px 20px 16px 0;
`;
